<template>
  <div>
    <div class="bg-white w-full flex flex-col h-32 border rounded border-gray-500" @click="choosePdfFile()">
      <div class="flex items-center justify-center" :class="textColorClass">
        <div class="w-1/5 icon-size text-center">
          <zt-icon name="images-outline" />
        </div>
        <div class="w-3/5 text-size pl-2">
          <span>{{ $t("message.FileUploadComponent.formComponent.selectDocument") }}</span>
        </div>
        <div class="w-1/5 icon-size text-center">
          <zt-icon name="angle-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['state', 'mutations'],
  data() {
    return {
      actualImageIndex: 0,
    }
  },
  computed: {
    isInIframe() {
      return window.self !== window.top;
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  },
  created() {
    this.actualImageIndex = this.state.documentsToUpload.length
  },
  methods: {
    choosePdfFile() {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = "application/pdf"
      input.onchange = e => {
        let file = e.target.files[0];
        if (file.type === 'application/pdf' && file.size <= 5000000) {
          let renderImage = { 'UrlOnLoad': URL.createObjectURL(file) }
          file = Object.assign(file, renderImage)
          let numberRandom = Math.floor(Math.random() * 10000)
          let mandatoryFile = {
            hash: "",
            name: "Generico",
            alias: "Generico",
            order: 10,
            value: file.name,
            mimeType: file.type,
            mandatory: true,
            file: file
          }
          let newFile = {
            alias: 'Generico Agregado ',
            hash: '',
            mandatory: false,
            mimeType: file.type,
            name: `Generico_Agregado_${numberRandom}`,
            order: numberRandom,
            value: file.name,
            file: file
          }
          if (this.actualImageIndex + 1 <= this.state.metadata.json.min_files) {
            this.mutations.addDocument(mandatoryFile)
          } else {
            this.mutations.addDocument(newFile)
          }
          this.mutations.setActiveOverlay(false)
        } else if (file.type === 'application/pdf' && file.size >= 500000) {
          this.$swal({
            type: "error",
            title: this.$t("message.FileUploadComponent.formComponent.checkSizeOnPdf"),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
          });
        } else {
          this.$swal({
            type: "error",
            title: this.$t("message.FileUploadComponent.formComponent.selectPdf"),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
          });
        }
      }
      this.mutations.setActiveOverlay(false)
      input.click()
    },
  }
}
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 2rem;
}

.text-size {
  font-size: 1rem;
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>